export const WORKINFO_ROUTES = {
  vancouver: 'Vancouver Work',
  squamish: 'Squamish Work',
  coastwise: 'Coastwise Work',
};